import rootService from 'core/services.root';

export default rootService({
    deleteVideoconference: ['DELETE', '/conference/delete/:id'],
    fetchVideoconference: ['GET', '/conference/:id'],
    fetchVideoconferences: ['GET', '/conference/list'],
    postVideoconference: ['POST', '/conference/store'],
    updateVideoconference: ['PUT', '/conference/update/:id']
});
